import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ClaimDto } from 'src/app/auto-generated-server-dtos/adjuster/claim/claim-dto';
import { ResetStatusService } from './services/reset-status.service';

@Component({
  selector: 'app-reset-claim-status',
  templateUrl: './reset-claim-status.component.html',
  styleUrl: './reset-claim-status.component.scss'
})
export class ResetClaimStatusComponent {
  @Input() claimDto!: ClaimDto;
  @Output() refreshClaim = new EventEmitter();

  isBusy: boolean = false;
  constructor(private resetStatusService: ResetStatusService) {
  }

  resetClaimStatus() {
    const defaultStatus = "Submitted";
    this.isBusy = true;
    this.resetStatusService.ResetStatus(this.claimDto.claimId).subscribe({
      next: () => {
        this.claimDto.status = defaultStatus;
        this.isBusy = false;
        this.refreshClaim.emit();
      }
    });
  }
  
}
